import { IkeToken } from '@ikegps/core-api';
import { T } from '../../i18n';
import { Services } from '../../services/index';
import { CurrentState } from '../../state/page.state';
import { CollectionFormModal } from '../collection.form.modal/collection.form.modal';
import { selectionExcludesVariants } from './collection.action.eligibility';

export const CollectionFormCtrl = {
	canDisplay(): boolean {
		return Services.Token.has(IkeToken.FEATURE_GROUP_IKE_ANALYZE) && selectionExcludesVariants();
	},

	showUpdateFormModal(): void {
		const collections = CurrentState.Tag.collections;
		const modal = new CollectionFormModal(
			{
				title: T.COLLECTION_UPDATE_FORM_TITLE,
				confirm: T.COLLECTION_UPDATE_FORM,
				success: {
					key: T.COLLECTION_UPDATE_FORM_SUCCESS,
				},
			},
			collections
		);

		modal.open();
	},
};
